/*
  Siddùra · Cantina e mappa
  Inizializza le mappe [data-cantina-map] quando entrano nello schermo.
  Provider: OpenStreetMap (Leaflet), Google Maps (con API key), carta stilizzata (SVG, d3).
  Le tappe vengono lette dai blocchi «Come arrivare» della stessa sezione ([data-cantina-poi]).
*/
(function () {
  if (window.SidCantina) { window.SidCantina.scan(); return; }

  var CDN = 'https://cdn.jsdelivr.net/npm/';
  var LEAFLET_CSS = CDN + 'leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_JS = CDN + 'leaflet@1.9.4/dist/leaflet.js';
  var D3_JS = CDN + 'd3@7.9.0/dist/d3.min.js';
  var TOPO_JS = CDN + 'topojson-client@3.1.0/dist/topojson-client.min.js';
  var ATLAS = CDN + 'world-atlas@2.0.2/countries-50m.json';
  var DESKTOP = 1000;
  var cache = {};

  function loadScript(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
    return cache[src];
  }

  function loadCss(href) {
    if (!document.querySelector('link[href="' + href + '"]')) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l);
    }
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function debounce(fn) { var t; return function () { clearTimeout(t); t = setTimeout(fn, 150); }; }
  function isDesktop() { return window.innerWidth >= DESKTOP; }
  function cssVar(el, name, fallback) { var v = getComputedStyle(el).getPropertyValue(name).trim(); return v || fallback; }
  function rgbVar(el, name, fallback) { var v = cssVar(el, name, ''); return v ? 'rgb(' + v + ')' : fallback; }

  function readOptions(el) {
    var d = el.dataset;
    var root = el.closest('.cantina') || document;
    var pois = [];
    if (d.pois !== 'false') {
      root.querySelectorAll('[data-cantina-poi]').forEach(function (p) {
        var lat = parseFloat(p.dataset.lat), lng = parseFloat(p.dataset.lng);
        if (p.dataset.onMap === 'false' || isNaN(lat) || isNaN(lng)) return;
        pois.push({ n: p.dataset.name || '', km: p.dataset.km || '', lat: lat, lng: lng, side: p.dataset.side || 'right', ray: p.dataset.ray !== 'false' });
      });
    }
    return {
      provider: d.provider || 'osm',
      key: (d.key || '').trim(),
      tiles: (d.tiles || '').trim(),
      lat: parseFloat(d.lat) || 41.036,
      lng: parseFloat(d.lng) || 9.173,
      zoom: parseInt(d.zoom, 10) || 11,
      offset: parseFloat(d.offset) || 0,
      offsetY: parseFloat(d.offsetY) || 0,
      style: d.style || 'mono',
      view: d.view || 'gallura',
      rays: d.rays || 'all',
      scroll: d.scroll === 'true',
      label: d.label || '',
      sublabel: d.sublabel || '',
      pois: pois
    };
  }

  function shiftX(el, o) { return isDesktop() ? (o.offset / 100) * el.clientWidth : 0; }
  function shiftY(el, o) { return isDesktop() ? (o.offsetY / 100) * el.clientHeight : 0; }

  /* ---------- OpenStreetMap (Leaflet) ---------- */
  function initOsm(el, o, host) {
    loadCss(LEAFLET_CSS);
    return loadScript(LEAFLET_JS).then(function () {
      var L = window.L;
      el.classList.add('cantina-map--' + o.style);
      var map = L.map(host, { zoomControl: false, scrollWheelZoom: o.scroll, attributionControl: true });
      L.control.zoom({ position: 'topright' }).addTo(map);
      L.tileLayer(o.tiles || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'
      }).addTo(map);

      var icon = function (html, w, h, ax, ay) { return L.divIcon({ className: '', html: html, iconSize: [w, h], iconAnchor: [ax, ay] }); };
      o.pois.forEach(function (p) {
        var left = p.side === 'left';
        L.marker([p.lat, p.lng], { icon: icon('<div class="cantina-poi"></div>', 10, 10, 5, 5), interactive: false }).addTo(map);
        L.marker([p.lat, p.lng], {
          icon: icon('<div class="cantina-poilbl' + (left ? ' cantina-poilbl--l' : '') + '">' + esc(p.n) + (p.km ? '<b>' + esc(p.km) + '</b>' : '') + '</div>', 170, 24, left ? 182 : -12, 12),
          interactive: false
        }).addTo(map);
      });

      var center = [o.lat, o.lng];
      L.marker(center, { icon: icon('<div class="cantina-pin"><i class="r"></i><i class="h"></i><i class="d"></i></div>', 18, 18, 9, 9), interactive: false, zIndexOffset: 1000 }).addTo(map);
      if (o.label) {
        L.marker(center, {
          icon: icon('<div class="cantina-pinlbl">' + esc(o.label) + (o.sublabel ? '<small>' + esc(o.sublabel) + '</small>' : '') + '</div>', 160, 30, -16, 10),
          interactive: false, zIndexOffset: 1000
        }).addTo(map);
      }

      var lastW = 0, lastH = 0;
      function place() {
        if (!host.clientWidth || !host.clientHeight) return;
        lastW = host.clientWidth; lastH = host.clientHeight;
        map.invalidateSize({ animate: false });
        map.setView(center, o.zoom, { animate: false });
        map.panBy([-shiftX(host, o), -shiftY(host, o)], { animate: false });
      }
      place();
      if (window.ResizeObserver) new ResizeObserver(function () { if (host.clientWidth !== lastW || host.clientHeight !== lastH) place(); }).observe(host);
      window.addEventListener('resize', debounce(place));
    });
  }

  /* ---------- Google Maps ---------- */
  var GSTYLES = {
    mono: [{elementType:'geometry',stylers:[{color:'#1c1c1c'}]},{elementType:'labels.text.fill',stylers:[{color:'#9b9b9b'}]},{elementType:'labels.text.stroke',stylers:[{color:'#121212'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{featureType:'poi',stylers:[{visibility:'off'}]},{featureType:'transit',stylers:[{visibility:'off'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#3a3a3a'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#202020'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#3c3c3c'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#141414'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#4e4e4e'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#8a8a8a'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0c0c0c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#5c5c5c'}]}],
    dark: [{elementType:'geometry',stylers:[{color:'#1e1a18'}]},{elementType:'labels.text.fill',stylers:[{color:'#a89f8e'}]},{elementType:'labels.text.stroke',stylers:[{color:'#151312'}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{featureType:'poi',stylers:[{visibility:'off'}]},{featureType:'transit',stylers:[{visibility:'off'}]},{featureType:'administrative',elementType:'geometry.stroke',stylers:[{color:'#3d3733'}]},{featureType:'landscape.natural',elementType:'geometry',stylers:[{color:'#221e1b'}]},{featureType:'road',elementType:'geometry',stylers:[{color:'#3d3733'}]},{featureType:'road',elementType:'geometry.stroke',stylers:[{color:'#151312'}]},{featureType:'road.highway',elementType:'geometry',stylers:[{color:'#4f4740'}]},{featureType:'road',elementType:'labels.text.fill',stylers:[{color:'#8f867a'}]},{featureType:'water',elementType:'geometry',stylers:[{color:'#0f0d0c'}]},{featureType:'water',elementType:'labels.text.fill',stylers:[{color:'#5e564d'}]}],
    light: [{stylers:[{saturation:-100}]},{elementType:'labels.icon',stylers:[{visibility:'off'}]},{featureType:'poi',stylers:[{visibility:'off'}]},{featureType:'transit',stylers:[{visibility:'off'}]}],
    none: []
  };

  function loadGoogle(key) {
    if (window.google && window.google.maps && window.google.maps.Map) return Promise.resolve();
    if (cache.google) return cache.google;
    cache.google = new Promise(function (resolve, reject) {
      window.__cantinaGmapsReady = resolve;
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&callback=__cantinaGmapsReady&loading=async&v=weekly';
      s.async = true; s.onerror = reject;
      document.head.appendChild(s);
    });
    return cache.google;
  }

  function initGoogle(el, o, host) {
    return loadGoogle(o.key).then(function () {
      var gm = window.google.maps;
      var accent = cssVar(el, '--c-accent', '#eac67d');
      var bg = rgbVar(el, '--background', '#151312');
      var text = rgbVar(el, '--text-color', '#ede3cf');
      var center = { lat: o.lat, lng: o.lng };
      var div = document.createElement('div'); div.className = 'cantina-gmap'; host.appendChild(div);
      var map = new gm.Map(div, {
        center: center, zoom: o.zoom, styles: GSTYLES[o.style] || GSTYLES.mono, backgroundColor: bg,
        disableDefaultUI: true, zoomControl: true, zoomControlOptions: { position: gm.ControlPosition.RIGHT_TOP },
        scrollwheel: o.scroll, gestureHandling: o.scroll ? 'greedy' : 'cooperative', clickableIcons: false
      });
      function dot(size, r, fill, stroke, halo) {
        var h = size / 2;
        var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 ' + size + ' ' + size + '">' +
          (halo ? '<circle cx="' + h + '" cy="' + h + '" r="' + (h - 1) + '" fill="' + fill + '" fill-opacity=".22"/>' : '') +
          '<circle cx="' + h + '" cy="' + h + '" r="' + r + '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="2"/></svg>';
        return { url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg), scaledSize: new gm.Size(size, size), anchor: new gm.Point(h, h), labelOrigin: new gm.Point(size + 10, h) };
      }
      o.pois.forEach(function (p) {
        new gm.Marker({ position: { lat: p.lat, lng: p.lng }, map: map, clickable: false, icon: dot(14, 4, text, bg, false),
          label: { text: p.n + (p.km ? ' · ' + p.km : ''), color: text, fontSize: '11px', fontWeight: '600', className: 'cantina-glbl' } });
      });
      new gm.Marker({ position: center, map: map, clickable: false, zIndex: 1000, icon: dot(28, 5, accent, bg, true),
        label: { text: o.label, color: accent, fontSize: '12px', fontWeight: '700', className: 'cantina-glbl' } });
      function place() { map.setCenter(center); map.panBy(-shiftX(host, o), -shiftY(host, o)); }
      gm.event.addListenerOnce(map, 'idle', place);
      window.addEventListener('resize', debounce(place));
    });
  }

  /* ---------- Carta stilizzata (SVG) ---------- */
  var atlasPromise = null;
  function loadAtlas() {
    if (!atlasPromise) {
      atlasPromise = loadScript(D3_JS).then(function () { return loadScript(TOPO_JS); }).then(function () {
        return fetch(ATLAS).then(function (r) { return r.json(); });
      });
    }
    return atlasPromise;
  }

  function initCarta(el, o, host) {
    return loadAtlas().then(function (topo) {
      var d3 = window.d3, topojson = window.topojson;
      var land = topojson.feature(topo, topo.objects.countries);
      var box = o.view === 'sardegna' ? [[8.05, 38.82], [9.95, 41.42]] : [[8.62, 40.72], [9.80, 41.33]];
      var frame = { type: 'Polygon', coordinates: [[[box[0][0], box[0][1]], [box[1][0], box[0][1]], [box[1][0], box[1][1]], [box[0][0], box[1][1]], [box[0][0], box[0][1]]]] };
      var accent = cssVar(el, '--c-accent', '#eac67d');
      var landFill = 'color-mix(in srgb, ' + rgbVar(el, '--text-color', '#ede3cf') + ' 5%, ' + rgbVar(el, '--background', '#151312') + ')';

      function draw() {
        var W = host.clientWidth, H = host.clientHeight;
        if (!W || !H) return;
        var svg = d3.select(host).selectAll('svg.cantina-carta').data([0]).join('svg').attr('class', 'cantina-carta').attr('viewBox', '0 0 ' + W + ' ' + H);
        svg.selectAll('*').remove();
        var pad = 36;
        var proj = d3.geoMercator().fitExtent([[pad, pad], [W - pad, H - pad]], frame);
        var t = proj.translate();
        proj.translate([t[0] + shiftX(host, o), t[1] + shiftY(host, o)]);
        var path = d3.geoPath(proj);
        svg.append('path').datum(d3.geoGraticule().step([.5, .5])()).attr('d', path).attr('fill', 'none').attr('stroke', accent).attr('stroke-opacity', .07);
        svg.append('path').datum(land).attr('d', path).attr('fill', landFill).attr('stroke', accent).attr('stroke-opacity', .6).attr('stroke-linejoin', 'round');
        var p = proj([o.lng, o.lat]);
        o.pois.forEach(function (d) {
          var a = proj([d.lng, d.lat]);
          if (o.rays !== 'none' && d.km && d.ray) {
            svg.append('line').attr('x1', a[0]).attr('y1', a[1]).attr('x2', p[0]).attr('y2', p[1]).attr('stroke', accent).attr('stroke-opacity', .55).attr('stroke-dasharray', '2 5').attr('stroke-linecap', 'round');
            svg.append('text').attr('class', 'cantina-carta__km').attr('x', (a[0] + p[0]) / 2).attr('y', (a[1] + p[1]) / 2 + 4).text(d.km);
          }
          if (a[0] < 8 || a[0] > W - 8 || a[1] < 8 || a[1] > H - 8) return;
          var left = d.side === 'left';
          svg.append('circle').attr('cx', a[0]).attr('cy', a[1]).attr('r', 2.6).attr('fill', 'currentColor').attr('fill-opacity', .8);
          svg.append('text').attr('class', 'cantina-carta__town').attr('x', a[0] + (left ? -9 : 9)).attr('y', a[1] + 4).attr('text-anchor', left ? 'end' : 'start').text(d.n);
        });
        svg.append('circle').attr('class', 'cantina-carta__pulse').attr('cx', p[0]).attr('cy', p[1]).attr('r', 14).attr('fill', 'none').attr('stroke', accent).attr('stroke-width', 1.2);
        svg.append('circle').attr('cx', p[0]).attr('cy', p[1]).attr('r', 11).attr('fill', accent).attr('fill-opacity', .18);
        svg.append('circle').attr('cx', p[0]).attr('cy', p[1]).attr('r', 5).attr('fill', accent).attr('stroke', rgbVar(el, '--background', '#151312')).attr('stroke-width', 2);
        if (o.label) {
          var right = o.view === 'sardegna';
          var lx = right ? p[0] + 20 : p[0] - 18;
          svg.append('text').attr('class', 'cantina-carta__name').attr('x', lx).attr('y', p[1] - 3).attr('text-anchor', right ? 'start' : 'end').text(o.label);
          if (o.sublabel) svg.append('text').attr('class', 'cantina-carta__sub').attr('x', lx).attr('y', p[1] + 14).attr('text-anchor', right ? 'start' : 'end').text(o.sublabel);
        }
      }
      host.style.color = rgbVar(el, '--text-color', '#ede3cf');
      draw();
      if (window.ResizeObserver) new ResizeObserver(debounce(draw)).observe(host);
    });
  }

  function init(el) {
    if (el.dataset.cantinaReady) return;
    el.dataset.cantinaReady = '1';
    var o = readOptions(el);
    var host = el.querySelector('[data-cantina-canvas]') || el;
    if (o.provider !== 'osm') el.classList.remove('cantina-map--mono', 'cantina-map--dark', 'cantina-map--light');
    var run = o.provider === 'google' && o.key ? initGoogle : o.provider === 'carta' ? initCarta : initOsm;
    run(el, o, host).catch(function (e) { console.warn('[siddura-cantina] mappa non disponibile', e); });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); init(e.target); } });
  }, { rootMargin: '600px 0px' }) : null;

  function scan() {
    document.querySelectorAll('[data-cantina-map]').forEach(function (el) {
      if (el.dataset.cantinaReady || el.dataset.cantinaSeen) return;
      el.dataset.cantinaSeen = '1';
      if (io) io.observe(el); else init(el);
    });
  }

  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 0); });
  document.addEventListener('shopify:block:select', function () { setTimeout(scan, 0); });
  window.SidCantina = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
